import { Navigate } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import { useHomepageRedirect, HomepageRedirectTarget } from "@akina/presentation";

export const HomePage = () => {
  const target = useHomepageRedirect(state => state.target);

  if (!target) return <Navigate to={AppRoutes.Dashboard} replace />;
  if (target === HomepageRedirectTarget.OnboardingError) {
    return <Navigate to={AppRoutes.OnboardingError} replace />;
  } else {
    return <Navigate to={AppRoutes.Dashboard} replace />;
  }
};
